<div class="error-page">
  <div class="content">
    <div class="message-container">
      <div>
        <h1>Oops...</h1>
        <h2>The page you requested could not be found.</h2>
        <div class="messages">
          <div>
            <p>
              The site you are trying to access, which is managed by FirsTech
              Inc., could be experiencing a service outage or planned downtime
              to update system configurations.
            </p>
            <p>
              We track these errors automatically, but if the problem persists
              please contact your support team.
            </p>
          </div>
          <p><strong>Apologies and please try again.</strong></p>
        </div>
      </div>
    </div>
    <div class="image-container">
      <img [src]="robotImgPath" alt="Tobi, the FirsTech, robot is sad." />
    </div>
  </div>
  <footer class="footer-container">
    <div class="footer-bar"></div>
    <div class="logo-container">
      <div>
        <img [src]="logoImgPath" alt="FirsTech Inc." />
      </div>
      <p>A Payment Processing Company</p>
    </div>
    <app-nav-links></app-nav-links>
  </footer>
</div>
